function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { BrowserPerformanceClient, PublicClientApplication } from '@azure/msal-browser';
import { logger } from '@src/logger';
import { Constants } from '@shared/utils/constants';
import { stringifyError } from '@shared/utils/errorUtils';
import { getConfig } from './config';
class AuthClient {
    static getInstance() {
        if (__CLIENT__) {
            if (!AuthClient.instance) {
                const config = getConfig();
                AuthClient.instance = new PublicClientApplication(_object_spread_props(_object_spread({}, config), {
                    telemetry: {
                        client: new BrowserPerformanceClient(config)
                    }
                }));
            }
            return AuthClient.instance;
        } else {
            console.warn('Cannot get PCA instance on server');
            return null;
        }
    }
    static initialize(_0) {
        return _async_to_generator(function*({ onSuccess, onFailure }) {
            const instance = AuthClient.getInstance();
            if (!AuthClient.initialized) {
                try {
                    yield instance.initialize();
                    AuthClient.initialized = true;
                    onSuccess();
                    logger.info('MSAL initialized successfully', {
                        action: Constants.Telemetry.Action.Login,
                        actionModifier: Constants.Telemetry.ActionModifier.MsalInitializationSuccess
                    });
                } catch (error) {
                    onFailure === null || onFailure === void 0 ? void 0 : onFailure();
                    logger.error(stringifyError(error), {
                        action: Constants.Telemetry.Action.Login,
                        actionModifier: Constants.Telemetry.ActionModifier.MsalInitializationError,
                        error
                    });
                }
            } else {
                onSuccess();
            }
        }).apply(this, arguments);
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(){
    // Private constructor to prevent direct construction calls
    }
}
_define_property(AuthClient, "instance", void 0);
_define_property(AuthClient, "initialized", false);
export default AuthClient;
